module.exports = __webpack_public_path__ + "img/portada.a78e30ee.svg";